/** Read at request time (SSR). Do not use for gating SSG pages. */
export function getLinkapiGatewayRoutingEnabled(): boolean {
  return process.env.NEXT_PUBLIC_LINKAPI_GATEWAY_ROUTING_ENABLED === 'true';
}

/** Build-time snapshot; prefer `getLinkapiGatewayRoutingEnabled()` on the server. */
export const isLinkapiGatewayRoutingEnabled = getLinkapiGatewayRoutingEnabled();
